import React, { useState, useEffect } from "react";
import { Table, Space, Form, Flex, message, Tooltip } from "antd";
import { CustomParagraph, AddItemButton, CustomTitle } from "../../components";
import chevronRight from "../../assets/images/chevron-right.svg";
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit-icon.svg";
import invitePlusIcon from "../../assets/images/invite-plus-icon.svg";
import resendIcon from "../../assets/images/resend.svg";
import { useNavigate } from "react-router-dom";
import { appHelper, useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import { GetUsers } from "../../api's/onboarding";
import TeamBadge from "../../components/TeamBadge";
import ColumnGroup from "antd/es/table/ColumnGroup";
import {
  DeletePendingInviteUser,
  DeleteUser,
  GetAllPendingUsers,
  ResendInvite,
} from "../../api's/settings";
import ToggleSwitch from "../../components/ToggleSwitch";
import CustomDeleteModal from "../Modals/CustomDeleteModal";
import AddNewContactModal from "../Modals/AddNewContactModal";
import { CreateNewShipment } from "../../api's/shipment";
import CommonDrawer from "../../components/CommonDrawer";
import SettingsInviteUserForm from "./SettingsInviteUserForm";
import { getTeamsDDL } from "../../common/utils/dropDown";
import { all } from "axios";

const InviteUserTable = ({fetchPendingUsers ,pendingUserList}) => {
  const { token, removeToken, decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { showSpin, hideSpin } = useSpin();
  const [userID, setUserID] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const {truncateByLength} = appHelper();
  // get all PENDING users
  // /api/auth/users/?is_pending=true

  const [allTeams, setAllTeams] = useState([]);

  useEffect(() => {
    getTeamsDDL(token).then((val) => {
      if (val && val.length > 0) {
        setAllTeams(val);
      }
    });
  }, []);

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  // delete user (API pending)
  const handleDelete = (record) => {
    setDeleteData(record);
    setShowDeleteModal(true);
  };

  // ****** pending invite user table Column ***********

  const handlePendingDelete = () => {
    setShowDeleteModal(false);
    if (deleteData && deleteData.id) {
      showSpin();
      DeletePendingInviteUser(token , deleteData.id)
        .then((res) => {
    
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              message.success(data?.data?.message);
              fetchPendingUsers();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  // re-send invite
  const handleResendInvite = (record) => {
    if (record && record.id) {
      showSpin();
      ResendInvite(token, { user_id: record.id })
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              message.success(data?.data?.message);
              fetchPendingUsers();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  const pendingUserColumns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: allTeams.length > 0 ? '489' : "978px",
      render: (text) => (
        <>
        <CustomParagraph
          text={text}
          noText="--"
          fontSize={14}
          fontWeight={600}
          color="#000"
          marginBottom={0}
        />
        </>
      ),
    },
    ...(allTeams.length > 0
      ? [
          {
            title: "Team",
            dataIndex: "teams",
            key: "teams",
            width: "489px",
            render: (_, record) => {
              return (
                <>
                  {record?.teams?.length > 0 ? (
                    <div className="flex gap-x-2">
                      <TeamBadge
                      Truncate={false}
                      tooltipText={`${record?.teams[0]?.name}: ${record?.teams[0]?.role_name}`}
                        color={record?.teams[0]?.color}
                        text={`${truncateByLength(record?.teams[0]?.name, 12)}: ${truncateByLength(record?.teams[0]?.role_name, 12)}`}
                      />
                      {record?.teams.length > 1 && (
                        <Tooltip
                          title={ record.teams.slice(1).map((team) => team.name).join(", ")}
                          placement="top" >
                          <div
                            style={{
                              display: "inline-block",
                              cursor: "pointer",
                            }}
                          >
                            <TeamBadge
                              color={null}
                              text={`+ ${record?.teams.length - 1}`}
                            />
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  ) : (
                    <p>--</p>
                  )}
                </>
              );
            },
          },
        ]
      : []),

    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <>
        <Flex gap={6}>
          {record?.permissions?.is_update &&
          <Flex
            justify="center"
            align="center"
            style={{ width: "32px", height: "32px", cursor: "pointer" }}
          >
            <img
              src={resendIcon}
              alt=""
              onClick={() => handleResendInvite(record)}
            />
          </Flex>}
          {record?.permissions?.is_delete &&

          <Flex
            justify="center"
            align="center"
            style={{ width: "32px", height: "32px", cursor: "pointer" }}
          >
            <img src={deleteIcon} alt="" onClick={() => handleDelete(record)} />
          </Flex>
    }
        </Flex>
        </>
      ),
    },
  ];

  return (
    <>
    <div className="settings-content-wrapper" style={{marginTop:"36px"}}>
      <CustomTitle
        text={`Pending invites (${pendingUserList?.length}) `}
        fontSize={20}
        fontWeight="700"
        lineHeight="32px"
        color="#000"
        marginTop={18}
        marginBottom={0}
      />
      <Table
        columns={pendingUserColumns}
        dataSource={pendingUserList}
        pagination={false}
        className="settings-table"
        rowHoverable={false}
      />

      <CustomDeleteModal
        visible={showDeleteModal}
        onClose={()=>setShowDeleteModal(false)}
        onConfirm={() => handlePendingDelete()}
        title={`Delete user`}
        message={`User will lose access from ZoomLogi and be removed from all notifications.`}
        cancelText={"Cancel"}
        confirmText={"Delete"}
        confirmColor={`#DE1135`}
      />
      </div>
    </>
  );
};

export default InviteUserTable;
